import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-biens-professionnels',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-biens-professionnels.component.html',
  styleUrls: ['./assurance-biens-professionnels.component.scss']
})
export class AssuranceBiensProfessionnelsComponent {
  title = 'Assurance des Biens pour Professionnels et Entreprises';
  subtitle = '';
  heroImage = 'assets/static_pages_images/Paysage_industriel.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance des Biens', link: undefined }
  ];

  prevPage = { title: 'Assurance des Biens pour Particuliers',
    link: '/assurance-biens-particuliers'
  };

  nextPage = { title: 'Assurance de l\'Activité des Professionnels et Entreprises',
    link: '/assurance-activite-professionnels'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
